import { render } from "./ContractReviewList.vue?vue&type=template&id=435f5cc4"
import script from "./ContractReviewList.vue?vue&type=script&lang=js"
export * from "./ContractReviewList.vue?vue&type=script&lang=js"

import "./ContractReviewList.vue?vue&type=style&index=0&id=435f5cc4&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__